import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAsignatures } from '../asginatures/Asignatures';
import { useInstitutions } from '../institutions/Institutions';
import { useSeries } from '../series/Series';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
  },
}));

function useForm(e) {
  const [entries, setEntries] = useState([]);
  function handleChange(e) {
    let { name, value } = e.target;
    if (value.includes('{') && value.includes('}')) {
      value = JSON.parse(value);
    }
    setEntries({ ...entries, [name]: value });
  }

  return {
    handleChange,
    entries,
  };
}

export function CreateTeacher(props) {
  const { asignatures } = useAsignatures();
  const { series } = useSeries();
  const { institutions } = useInstitutions();
  const { entries, handleChange } = useForm();
  const classes = useStyles();
  const navigate = useNavigate();

  const handleCreate = () => {
    fetch('https://api.edicionesmilenio.com/api/teachers', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(entries),
    })
      .then((response) => response.json())
      .then((json) => {
        navigate('/admin/teachers');
      });
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás crear un nuevo docente
        para la plataforma, asignandole la institución, asignaturas y series que
        imparte para una correcta configuración.
      </p>
      <div
        style={{
          width: '100%',
          paddingLeft: '20px',
          paddingRight: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <TextField
          className={classes.input}
          label="Correo"
          variant="outlined"
          name="email"
          value={entries?.email}
          onChange={handleChange}
          type={'email'}
        />
        <TextField
          className={classes.input}
          label="Contraseña"
          variant="outlined"
          name="password"
          value={entries?.password}
          onChange={handleChange}
          type={'password'}
        />
        <TextField
          className={classes.input}
          label="Nombre"
          variant="outlined"
          name="name"
          value={entries?.name}
          onChange={handleChange}
        />
        <TextField
          className={classes.input}
          label="Apellido"
          variant="outlined"
          name="lastName"
          value={entries?.lastName}
          onChange={handleChange}
        />
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-asignatures-label">Asignaturas</InputLabel>
          <Select
            labelId="select-asignatures-label"
            id="select-asignatures"
            name="asignatures"
            value={entries?.asignatures || []}
            onChange={handleChange}
            multiple
            label={'Asignaturas'}
          >
            {asignatures.map((asignature) => (
              <MenuItem value={asignature?._id}>{asignature?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-series-label">Series</InputLabel>
          <Select
            labelId="select-series-label"
            id="select-series"
            name="series"
            value={entries?.series || []}
            onChange={handleChange}
            multiple
            label={'Series'}
          >
            {series.map((serie) => (
              <MenuItem value={serie?._id}>{serie?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-institutions-label">Institución</InputLabel>
          <Select
            labelId="select-institutions-label"
            id="select-institutions"
            name="institution"
            value={entries?.institution}
            onChange={handleChange}
            label={'Institución'}
          >
            {institutions.map((institution) => (
              <MenuItem value={institution?._id}>{institution?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={handleCreate}
          className={classes.input}
          variant="contained"
          color="primary"
          disabled={
            !entries?.name ||
            !entries?.lastName ||
            !entries?.asignatures ||
            !entries?.series ||
            !entries?.institution
          }
        >
          Crear
        </Button>
      </div>
    </div>
  );
}
